<template>
  <!-- 修改个人信息 -->
  <el-dialog :title="title" :visible.sync="dialogVisible" width="426px">
    <el-form :model="form" label-width="70px" class="demo-ruleForm">
      <div :class="formList[0].warnInfo ? 'warnInfo' : ''">{{ formList[0].warnInfo }}</div>
      <el-form-item v-for="(item, index) in formList" :key="index" :label="item.title">
        <!-- 验证码 -->
        <el-input v-if="item.prop === 'testWord'" v-model="form[item.prop]" :placeholder="item.placeholder">
          <template slot="append">
            <span v-show="show" @click="sendTestCode">发送验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </template>
        </el-input>
        <!-- 角色 -->
        <el-checkbox-group v-else-if="item.prop === 'role'" v-model="form[item.prop]">
          <el-checkbox v-for="item in roleList" :label="item.title" :key="item.title">{{ item.title }}</el-checkbox>
        </el-checkbox-group>
        <!-- 输入框 -->
        <el-input v-else v-model="form[item.prop]" :placeholder="item.placeholder"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :disabled="!disabled">{{ formList[0].sureBtn }}</el-button>
      <el-button @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  computed: {
    disabled() {
      var obj = {};
      var disabled = true;
      for (var item in this.form) {
        this.formList.map(el => {
          if (item == el.prop) {
            Object.assign(obj, { [item]: this.form[item] });
          }
        });
      }
      for (var key in obj) {
        if (obj[key] === '') {
          disabled = false;
        }
      }
      return disabled;
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: '修改信息',
      // 表单信息
      form: {
        name: '',
        email: '',
        oldPassword: '',
        newPasseord: '',
        repertPassword: '',
        phone: '',
        testWord: '',
        role: [],
      },
      // 角色
      roleList: [
        { title: '普通成员' },
        { title: '财务' },
        { title: '技术' },
        { title: '运营' },
        { title: '普通管理原' },
      ],
      sureBtn: '确定',
      success: () => {},
      // 倒计时
      show: true,
      count: '',
      timer: null,
    };
  },
  methods: {
    submitForm() {
      this.success(this.form);
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    // 发送验证码
    sendTestCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-input {
  width: 312px;
  height: 40px;
}
/deep/.el-dialog__header {
  padding-bottom: 30px;
}
/deep/.el-dialog__body {
  padding: 0 24px 0 20px;
}
/deep/.el-form-item__label {
  padding: 0;
}
.warnInfo {
  margin: 0 0 20px 0;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #666666;
}
/deep/.el-input-group__append {
  width: 90px;
  border: 1px solid #4359b7;
  color: #4359b7;
  padding: 0;
  background: none;
  text-align: center;
  border-radius: 4px;
  left: -2px;
  cursor: pointer;
}
.dialog-footer {
  .el-button {
    padding: 8px 16px;
    font-size: 12px;
  }
}
</style>
